/**
 * Script pour supprimer spécifiquement les erreurs connues non critiques
 * Principalement les conflits entre extensions de wallet
 */

// Liste des patterns d'erreur à supprimer
const SUPPRESSED_ERROR_PATTERNS = [
  // Conflits Solflare/Metamask
  'solflare-detect-metamask',
  'StreamMiddleware - Unknown response id',
  'overrideMethod @ hook.js',
  '_postMessage @ contentscript.js',
  '_onMessage @ contentscript.js',
  'inpage.js:1 StreamMiddleware',
  
  // Erreurs Firestore temporaires (déjà gérées par notre handler)
  'POST https://firestore.googleapis.com/google.firestore.v1.Firestore/Write/channel',
  'webchannel_blob_es2018.js',
  
  // Warnings React Router v7 non critiques
  'React Router Future Flag Warning',
  'v7_startTransition',
  'v7_relativeSplatPath',
  
  // Phantom wallet standard warnings
  'Phantom was registered as a Standard Wallet'
];

// Fonction pour vérifier si une erreur doit être supprimée
function shouldSuppressError(message: string): boolean {
  return SUPPRESSED_ERROR_PATTERNS.some(pattern => 
    message.toLowerCase().includes(pattern.toLowerCase())
  );
}

// Store des fonctions console originales
const originalConsole = {
  error: console.error,
  warn: console.warn,
  log: console.log
};

// Compteur pour éviter le spam
const errorCounts = new Map<string, number>();
const MAX_SAME_ERRORS = 2;

/**
 * Installation du suppresseur d'erreurs
 */
export function installErrorSuppressor() {
  // Override console.error
  console.error = (...args: any[]) => {
    const message = args.join(' ');
    
    if (shouldSuppressError(message)) {
      // Log silencieux pour debugging
      if (process.env.NODE_ENV === 'development') {
        originalConsole.log('🔇 Erreur supprimée:', message.substring(0, 80) + '...');
      }
      return;
    }
    
    // Limiter les erreurs répétitives
    const errorKey = message.substring(0, 100);
    const count = errorCounts.get(errorKey) || 0;
    errorCounts.set(errorKey, count + 1);
    
    if (count < MAX_SAME_ERRORS) {
      originalConsole.error(...args);
    } else if (count === MAX_SAME_ERRORS) {
      originalConsole.error('... (erreur similaire supprimée pour éviter le spam)');
    }
  };

  // Override console.warn
  console.warn = (...args: any[]) => {
    const message = args.join(' ');
    
    if (shouldSuppressError(message)) {
      return;
    }
    
    originalConsole.warn(...args);
  };

  console.log('🔇 Suppresseur d\'erreurs activé');
}

/**
 * Désinstallation du suppresseur (pour debugging)
 */
export function uninstallErrorSuppressor() {
  console.error = originalConsole.error;
  console.warn = originalConsole.warn;
  console.log('🔊 Suppresseur d\'erreurs désactivé');
}

/**
 * Reset des compteurs d'erreur
 */
export function resetErrorCounts() {
  errorCounts.clear();
  console.log('🔄 Compteurs d\'erreurs remis à zéro');
}

// Auto-installation en développement
if (process.env.NODE_ENV === 'development') {
  installErrorSuppressor();
  
  // Ajouter des commandes globales pour debugging
  (window as any).__debugErrorSuppressor = {
    install: installErrorSuppressor,
    uninstall: uninstallErrorSuppressor,
    reset: resetErrorCounts,
    patterns: SUPPRESSED_ERROR_PATTERNS
  };
}
